import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { latestArrivals, vehicles } from "@/lib/inventory";
import { Reveal } from "@/components/motion/Reveal";
import { SectionHeading } from "@/components/site/Shared";
import { VehicleCard } from "@/components/vehicles/VehicleCard";

export const LatestArrivals = () => {
  const cars = latestArrivals(6);
  return (
    <section className="py-16 lg:py-24" aria-labelledby="latest-heading" data-testid="latest-arrivals-section">
      <div className="container-x">
        <SectionHeading
          id="latest-heading"
          eyebrow="Latest arrivals"
          title="Fresh on the forecourt."
          intro="The newest additions to our stock, with photos, prices and specs taken straight from our adverts."
          action={
            <Link to="/used-cars" className="btn btn-outline" data-testid="latest-view-all-button">
              View all {vehicles.length} cars <ArrowRight className="arrow" aria-hidden="true" />
            </Link>
          }
        />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {cars.map((v, i) => (
            <Reveal key={v.id} delay={(i % 3) * 0.08}>
              <VehicleCard v={v} tag={i === 0 ? "Just in" : undefined} testId={`latest-card-${i}`} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
